import React, { Component } from "react";

import { Button } from "@progress/kendo-react-buttons";
import { Input } from "@progress/kendo-react-inputs";
import $ from "jquery";
import TipoOptionForm from "./TipoOptionForm";
import queryString from "query-string";
import services from "../../../services";
import { toast } from "react-toastify";
import ClassGrid from "./Grid1/ClassGrid";
import DropDownCellIntervaloSelosGarantia from "./myDropDownCellIntervaloSelosGarantia";
import SelectCellSelosGarantia from "./mySelectCellSelosGarantia";
var lengthDadosVasilhas;
var DetalhesVasilhas =  "undefined"
var indexComponent = 0
var idVasilhaGrid = 0
var otherThis;

var GarantiaMovimentos = []
var DadosVasilha;

var resultIntervalo = null;
var seloInicial = null;
var seloFinal = null;

var FieldSelect = "";

class mySelosGarantia extends Component {

    componentDidMount() {

        otherThis = this;
        
        (async () => {   
            var idTipoVasilhaGrid = 0

            var  dataToken = {}
            var Detalhes = await services.apiCall.requestApi(
                "/InstalacaoVinica/GetAllTipoVasilha",
                dataToken,
                "get"
            ); 
            
            var strHTML = "<option value='0' selected>Selecione...</option>";
            for (let index = 0; index < Detalhes.length; index++) {

                var TipoVasilha = Detalhes[index].tipoVasilha;
                var idTipoVasilha = Detalhes[index].idTipoVasilha;
              
                strHTML = strHTML + "<option value='" + idTipoVasilha + "'>" + TipoVasilha + "</option>";

            }

            $("#tipoVasilhas").html(strHTML)
            
        })(); 
        
    }

    componentDidUpdate(prevProps, prevState) {
        
       
    }

    static addValueToarray = (e,remove) => {

        if(remove){
            GarantiaMovimentos = [];
        }

        e.map((element, index) => (

            GarantiaMovimentos.push(element)

        ));        

    }

    static getEntrouPelaGrid = (field) => {

        FieldSelect = field;

        if(otherThis != null){
            otherThis.componentDidMount()
        }

    }

    handleChange = e => {
        this.props.onChange({
            dataIndex: 0,
            dataItem: this.props.dataItem,
            field: this.props.field,
            syntheticEvent: e.syntheticEvent,
            value: e.target.value
        });
    }

    incrementValue = (id) => {
        if($('#' + id).val() != null & $('#' + id).val() != ""){
            var value = parseInt($('#' + id).val(), 10);
            value = new Array(8 - (value + '').length).join('0') + (value);
            return value;
        }
    }

    handleSubmit = () => {
        
        resultIntervalo = DropDownCellIntervaloSelosGarantia.returnValue();

        if($('#seloInicial').val() == null || $('#seloFinal').val() == null || resultIntervalo == null){

            toast.error("Preencha todos os campos");
            return;
        }

        if(parseInt($('#seloInicial').val()) > parseInt($('#seloFinal').val())){
            toast.error("Selo inicial tem que ser menor que o selo final");
            return;
        }
        
        if($('#seloInicial.k-state-invalid').length == 0 && $('#seloFinal.k-state-invalid').length == 0){
            seloInicial = this.incrementValue('seloInicial');
            seloFinal = this.incrementValue('seloFinal');
        }else{
            toast.error("Erro no intervalo dos selos");
            return;
        }

        var objectGarantia = {"idIntervalo" : resultIntervalo,'seloInicial':seloInicial,'seloFinal':seloFinal,'criadoPor':localStorage.username, 'field' : FieldSelect};

        GarantiaMovimentos.push(objectGarantia);
        
        SelectCellSelosGarantia.addNewSelosGarantia(GarantiaMovimentos)

        $(".left-popup").trigger("click");

    };

    

    canclePopup = () => {
        ////console.log("OKOK");
        this.setState({
            forFilter: {},
            form: {},
        });
        $(".left-popup").trigger("click");
    };

    render() {

        otherThis = this;

        return (
            


            <div className="modal-content">
                <div className="modal-header">
                    <span
                        className="modal-title bold"
                        style={{ fontSize: "large" }}
                    >
                        <b>Selecionar Selos Garantia</b>
                    </span>
                    <Button
                        className="success btn-ivdp-primary l-350 mr-3"
                        primary={true}
                        onClick={() => this.handleSubmit()}
                    >
                        Gravar
                    </Button>
                    <Button
                        className="remoove k-primary btn-ivdp-secondary btn-theme ml-1 mr-2"
                        onClick={() => this.canclePopup()}
                    >
                        Cancelar
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="model-body">

                        <div class="input-box active-grey">
                            <div class="col-md-12">
                                <div class="input-box active-grey drop-down-box">
                                    <label class="input-label" style={{zIndex: "9"}}>Intervalo</label>
                                    <DropDownCellIntervaloSelosGarantia/>
                                </div>
                                <div class="input-box active-grey drop-down-box">
                                    <label class="input-label" style={{zIndex: "9"}}>Selo inicial</label>
                                    <Input type="number" class="input-1 seloInicial blockSpecialChar" name="seloInicial" id="seloInicial" />
                                </div>
                                <div class="input-box active-grey drop-down-box">
                                    <label class="input-label" style={{zIndex: "9"}}>Selo final</label>
                                    <Input type="number" class="input-1 seloFinal blockSpecialChar" name="seloFinal" id="seloFinal" />
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>





            


        );
    }
}

export default mySelosGarantia;
